export default __webpack_public_path__ + "static/media/06_THIRSTY.32fa4cdb.png";